import { CheckupRequestInfo } from '@companion-professional/dctypes';
import React from 'react';
import { usePageTimeTracking } from '../../../hooks/usePageTimeTracking';

interface BasePageProps {
  renderChild: () => React.ReactNode;
  pageKind: string;
  checkupRequest: CheckupRequestInfo;
  page: number;
}

// This is the base page component that renders all the pages in the checup worflow
// and also tracks important common metrics for each custom page. 
const BasePage = ({ 
    renderChild, 
    pageKind, 
    page 
}: BasePageProps) => {
    // This is used to track the time spent on the custom pages.
    usePageTimeTracking({
        pageKind,
        page
     });

    return (
        <>
            {renderChild()}
        </>
    );
};

export default BasePage;
